'use strict';

var assert = require('assert'),
  geojsonhint = require('geojsonhint/object'),
  makeService = require('../make_service'),
  constants = require('../constants');

var MapboxMatching = makeService('MapboxMatching');

/**
 * Snap recorded location traces to roads and paths from OpenStreetMap.
 * Consult the [Map Matching API](https://www.mapbox.com/developers/api/map-matching/)
 * for more documentation.
 *
 * @param {Object} trace a single [GeoJSON](http://geojson.org/)
 * Feature with a LineString geometry, containing up to 100 positions.
 * @param {Object} [options={}] additional options meant to tune
 * the request
 * @param {string} [options.profile=mapbox.driving] the directions
 * profile, which determines how to prioritize different routes.
 * Options are `'mapbox.driving'`, which assumes transportation via an
 * automobile and will use highways, `'mapbox.walking'`, which avoids
 * streets without sidewalks, and `'mapbox.cycling'`, which prefers streets
 * with bicycle lanes and lower speed limits for transportation via
 * bicycle.
 * @param {string} [options.geometry=geojson] format for the returned
 * route. Options are `'geojson'`, `'polyline'`, or `false`: `polyline`
 * yields more compact responses which can be decoded on the client side.
 * [GeoJSON](http://geojson.org/), the default, is compatible with libraries
 * like [Mapbox GL](https://www.mapbox.com/mapbox-gl/),
 * Leaflet and [Mapbox.js](https://www.mapbox.com/mapbox.js/). `false`
 * omits the geometry entirely and only returns matched points.
 * @param {number} [options.gps_precision=4] An integer in meters indicating
 * the assumed precision of the used tracking device. Use higher
 * numbers (5-10) for noisy traces and lower numbers (1-3) for clean
 * traces. The default value is 4.
 * @param {Function} callback called with (err, results)
 * @returns {undefined} nothing, calls callback
 * @memberof MapboxClient
 * @example
 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
 * mapboxClient.matching({
 *   "type": "Feature",
 *   "properties": {
 *     "coordTimes": [
 *       "2015-04-21T06:00:00Z",
 *       "2015-04-21T06:00:05Z",
 *       "2015-04-21T06:00:10Z",
 *       "2015-04-21T06:00:15Z",
 *       "2015-04-21T06:00:20Z"
 *     ]
 *     },
 *   "geometry": {
 *     "type": "LineString",
 *     "coordinates": [
 *       [ 13.418946862220764, 52.50055852688439 ],
 *       [ 13.419011235237122, 52.50113000479732 ],
 *       [ 13.419756889343262, 52.50171780290061 ],
 *       [ 13.419885635375975, 52.50237416816131 ],
 *       [ 13.420631289482117, 52.50294888790448 ]
 *     ]
 *   }
 * },
 *   function(err, res) {
 *   // res is a document with directions
 * });
 */
MapboxMatching.prototype.matching = function(trace, options, callback) {

  // permit the options argument to be omitted
  if (callback === undefined && typeof options === 'function') {
    callback = options;
    options = {};
  }

  // typecheck arguments
  assert(geojsonhint.hint(trace).length === 0, 'trace must be valid GeoJSON');
  assert(typeof options === 'object', 'options must be an object');
  assert(typeof callback === 'function', 'callback must be a function');

  var profile = 'mapbox.driving',
    gps_precision = 4,
    geometry = 'geojson';


  if (options.gps_precision !== undefined) {
    assert(typeof options.gps_precision === 'number', 'gps_precision must be a number');
    gps_precision = options.gps_precision;
  }

  if (options.profile) {
    assert(typeof options.profile === 'string', 'profile option must be string');
    profile = options.profile;
  }

  if (options.geometry) {
    assert(typeof options.geometry === 'string', 'geometry option must be string');
    geometry = options.geometry;
  }

  this.client({
    path: constants.API_MATCHING,
    params: {
      profile: profile,
      geometry: geometry,
      gps_precision: gps_precision
    },
    method: 'post',
    entity: trace,
    callback: callback
  });
};

module.exports = MapboxMatching;



//////////////////
// WEBPACK FOOTER
// ./~/mapbox/lib/services/matching.js
// module id = 116
// module chunks = 0